const EVENT_SOURCE_KEY = "EVENT_SOURCE";

export const setEventSource = (source: string): void => {
  sessionStorage.setItem(EVENT_SOURCE_KEY, source);
};

export const getEventSource = (): string | null => {
  return sessionStorage.getItem(EVENT_SOURCE_KEY);
};
export const clearEventSource = (): void => {
  sessionStorage.removeItem(EVENT_SOURCE_KEY);
};

export enum SearchResultSource {
  FEED = "feed",
  ANSWER = "answer",
  SEARCH_DRAWER = "search_drawer",
  HOME = "home",
  ARTICLES = "articles",
  OLD_SEARCH = "search_page"
}
export enum SearchTriggerSource {
  NEXT_STEPS = "next_steps",
  URL = "url",
  SEARCH_BOX = "search_box",
  RECENT_SEARCHES = "recent_searches",
  TICKET_LOADED = "ticket_loaded"
}
